<template>
  <p class="lit-item" ref="element">
    <template v-if="showLabel">
      <template v-if="label">
        {{ label }}
      </template>
      <template v-else>
        ?
      </template>
    </template>
    {{ formattedLink }}
    <!--
    <template v-if="firstAuthor">
      <template>{{firstAuthor.lastName | capitalize}}</template><template v-if="firstAuthor.firstNameInitial">,</template>
      <template>{{firstAuthor.firstNameInitial}}.</template>
      <template>{{firstAuthor.extraNameInitial}}.</template>
    </template>
    <template>{{ content.title }} [Текст]</template>
    <template v-if="content.authors && content.authors.length > 0">/</template>
    <template v-if="content.authors && content.authors.length > 0">
      <template v-for="(author, authorIndex) in content.authors">
        <template>{{author.firstNameInitial}}.</template>
        <template>{{author.extraNameInitial}}.</template>
        <template>{{author.lastName | capitalize}}</template><template v-if="authorIndex < content.authors.length - 1">, </template>
      </template>
    </template>
    <template>//</template>
    <template>{{ content.source }}</template>
    <template v-if="content.type === 'resource'">[сайт]</template>
    <template v-if="content.year"> — {{ content.year }} г.</template>
    <template v-if="content.issue"> — № {{ content.issue }}</template>
    <template v-if="content.pages"> — C. {{ content.pages }}</template>
    <template v-if="content.type === 'resource' && content.url">
      . — режим доступа: {{ content.url }} 
      <template v-if="accessModeTitle">
        {{ accessModeTitle }}
      </template>
      <template v-if="accessDateTitle">
        (дата обращения: {{ accessDateTitle }})
      </template>
      <template v-if="accessModeTitle">
      . – Загл. с экрана.
      </template>
    </template>
    -->
  </p>
</template>

<script>
import _ from 'lodash'
import accessModes from '@/vocabularies/accessModes.js'
import linkFormat from '@/shared/linkFormat.js'
import moment from 'moment'

export default {
  filters: {
    capitalize: _.capitalize
  },
  computed: {
    formattedLink () {
      if (this.content) {
        return linkFormat(this.content)
      } else {
        return ''
      }
    },
    firstAuthor () {
      if (this.content && this.content.authors && this.content.authors[0]) {
        return this.content.authors[0]
      } else {
        return null
      }
    },
    accessModeTitle () {
      if (this.content.accessMode) {
        const value = accessModes.find(am => am.key === this.content.accessMode)
        if (value) {
          return value.title
        }
      }
      return null
    },
    accessDateTitle () {
      if (this.content.accessDate) {
        const dateValue = moment(this.content.accessDate, 'YYYY-MM-DD')
        if (dateValue) {
          return dateValue.format('DD.MM.YYYY')
        }
      }
      return null
    }
  },
  methods: {
    onRemove () {
      this.$emit('remove', this.content)
    },
    getContent () {
      return this.$refs.element.innerHTML
    }
  },
  props: {
    content: Object,
    label: String,
    showLabel: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="sass">
.lit-item
  .author:last-child
    .author-separator
      display: none
</style>


// WEBPACK FOOTER //
// LitListItemView.vue?76871ab4